import LegalPageLayout, { LegalSection } from "@/components/LegalPageLayout";

export default function CookiesPage() {
  return (
    <LegalPageLayout
      title="Politique relative aux cookies"
      path="/politique-cookies"
      description="Politique cookies du site Express Delivery : mesure d'audience et fonctionnement du site."
      testId="cookies-page"
    >
      <LegalSection title="Qu'est-ce qu'un cookie ?">
        <p>
          Un cookie est un petit fichier déposé sur votre appareil lors de la consultation d'un site. Il permet
          notamment d'assurer le bon fonctionnement du site et de mesurer son audience.
        </p>
      </LegalSection>
      <LegalSection title="Cookies utilisés sur ce site">
        <p>Ce site utilise uniquement :</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>des cookies techniques nécessaires au fonctionnement du site ;</li>
          <li>un outil de mesure d'audience permettant d'améliorer le site et le parcours de demande de devis.</li>
        </ul>
        <p className="mt-2">Aucun cookie publicitaire n'est utilisé. Aucune donnée n'est revendue à des tiers.</p>
      </LegalSection>
      <LegalSection title="Gérer les cookies">
        <p>
          Vous pouvez configurer votre navigateur pour bloquer ou supprimer les cookies. Le blocage des cookies
          techniques peut toutefois altérer certaines fonctionnalités (formulaires, envoi de photos).
        </p>
      </LegalSection>
      <LegalSection title="Contact">
        <p>Pour toute question relative aux cookies : voir la page Politique de confidentialité.</p>
      </LegalSection>
    </LegalPageLayout>
  );
}
